import { timingKey } from './orderTiming';

const ASAP = { type: 'asap', value: 'asap', label: 'ASAP' };

// A target is deliberate intent even if expired/malformed: retain it for the
// existing picker recovery. Empty/partial default records are not a choice.
const hasIntent = (time) =>
  ['asap', 'target'].includes(time?.type) ||
  (time?.value != null &&
    typeof time.value === 'object' &&
    ('start' in time.value || 'end' in time.value));
export const restoreOrderTime = (time, fallback) => {
  if (hasIntent(time)) return time;
  return hasIntent(fallback) ? fallback : null;
};
export const resolveListingOrderTime = (time, legacyTime) => {
  const intent = restoreOrderTime(time, legacyTime) ?? ASAP;
  if (
    intent.type === 'asap' &&
    (typeof intent.value !== 'object' ||
      !Number.isFinite(Number(intent.value?.end)) ||
      Number(intent.value?.end) <= Date.now() / 1000)
  )
    return intent.value === 'asap' && intent.label === 'ASAP' ? intent : ASAP;
  return intent;
};

export const isUsableOrderTime = (time, now = Date.now()) =>
  !!timingKey('selection', 'selection', time) &&
  (time.type === 'asap' || Number(time.value.end) > now / 1000);

export const sameOrderTime = (first, second) =>
  !!first &&
  !!second &&
  timingKey('selection', 'selection', first) !== null &&
  timingKey('selection', 'selection', first) ===
    timingKey('selection', 'selection', second);
